export const USER_COLOR_ARRAY = [
    {
        light: 'var(--palette-pink-20)',
        dark: 'var(--palette-pink-110)',
    },
    {
        light: 'var(--palette-purple-10)',
        dark: 'var(--palette-purple-100)',
    },
    {
        light: 'var(--palette-blue-10)',
        dark: 'var(--palette-blue-100)',
    },
    {
        light: 'var(--palette-green-10)',
        dark: 'var(--palette-green-100)',
    },
    {
        light: 'var(--palette-magenta-10)',
        dark: 'var(--palette-magenta-90)',
    },
    {
        light: 'var(--palette-orange-20)',
        dark: 'var(--palette-orange-100)',
    },
    {
        light: 'var(--palette-yellow-20)',
        dark: 'var(--palette-yellow-120)',
    },
];

export const NEW_UI_USER_COLOR_ARRAY_LIGHT = [
    {
        light: 'var(--data-viz-chart-color-1-subdued)',
        dark: 'var(--color-magenta-70)',
    },
    {
        light: 'var(--data-viz-chart-color-6-subdued)',
        dark: 'var(--color-purple-70)',
    },
    {
        light: 'var(--data-viz-chart-color-2-subdued)',
        dark: 'var(--color-blue-80)',
    },
    {
        light: 'var(--data-viz-chart-color-4-subdued)',
        dark: 'var(--color-green-80)',
    },
    {
        light: 'var(--data-viz-chart-color-7-subdued)',
        dark: 'var(--color-mauve-60)',
    },
    {
        light: 'var(--data-viz-chart-color-3-subdued)',
        dark: 'var(--color-coral-80)',
    },
    {
        light: 'var(--data-viz-chart-color-9-subdued)',
        dark: 'var(--color-yellow-orange-70)',
    },
];

export const NEW_UI_USER_COLOR_ARRAY_DARK = [
    {
        light: 'var(--color-pink-20)',
        dark: 'var(--color-pink-110)',
    },
    {
        light: 'var(--color-purple-10)',
        dark: 'var(--color-purple-100)',
    },
    {
        light: 'var(--color-blue-10)',
        dark: 'var(--color-blue-100)',
    },
    {
        light: 'var(--color-green-10)',
        dark: 'var(--color-green-100)',
    },
    {
        light: 'var(--color-magenta-10)',
        dark: 'var(--color-magenta-90)',
    },
    {
        light: 'var(--color-orange-20)',
        dark: 'var(--color-orange-100)',
    },
    {
        light: 'var(--color-yellow-20)',
        dark: 'var(--color-yellow-120)',
    },
];

function isNewUiApplied () {
    return document.documentElement?.getAttribute('data-ui') === 'new';
}

function isDarkModeApplied () {
    return document.documentElement?.getAttribute('data-theme') === 'dark';
}

export function calculateUsernameColor (username, isNewUiEnabled = false, isDarkModeEnabled = false) {
    const usernameArray = username ? [...username] : [];

    const nameValue = usernameArray.reduce((acc, char) => {
        return char.charCodeAt() + acc;
    }, 0);
    const useNewUiColors = isNewUiEnabled && isNewUiApplied();
    const useDarkModeColors = isDarkModeEnabled && isDarkModeApplied();

    let colorArray = USER_COLOR_ARRAY;

    if (useNewUiColors) {
        colorArray = useDarkModeColors ? NEW_UI_USER_COLOR_ARRAY_DARK : NEW_UI_USER_COLOR_ARRAY_LIGHT;
    }

    const colorValue = nameValue % colorArray.length;
    const borderColorVariable = `var(--raw-${colorArray[colorValue].dark.slice(6, -1)})`;

    return {
        'background-color': colorArray[colorValue].light,
        'color': colorArray[colorValue].dark,
        'border-color': `rgba(${borderColorVariable}, 0.3)`,
    };
}

export function formatUserFullName ({ first = '', last = '', username = '', fullName = '' }) {
    if (fullName) {
        return fullName;
    }

    if (first && last) {
        return `${first} ${last}`;
    }

    return username;
}
